import React from 'react'
import { useHistory } from 'react-router'

import Button from 'components/Button'
import Close2 from 'components/Icons/Close2'

const HeaderDropdown = ({
  open,
  onClose,
  title,
  items,
  emptyIcon: EmptyIcon,
  emptyTitle,
  emptyMessage,
  buttonText,
  buttonRoute,
  renderItem,
  rightOffset = '-right-6',
  tooltipRightOffset = '-right-8',
}) => {
  const history = useHistory()

  const handleClose = () => {
    onClose()
  }

  const handleButtonClick = () => {
    history.push(buttonRoute)
    handleClose()
  }

  return (
    <div
      className={`absolute top-[45px] ${rightOffset} z-[999] w-80 md:w-[400px] transition-all duration-300 ease-in-out border border-[#ff2337] rounded-md ${
        open
          ? 'opacity-100 scale-100 translate-y-0'
          : 'opacity-0 scale-90 translate-y-5 pointer-events-none'
      }`}
    >
      <div
        className={`absolute -top-[7px] ${tooltipRightOffset} w-3 h-3 bg-white border-l border-t border-[#ff2337] transform rotate-45`}
      ></div>

      <div className="bg-white rounded-md overflow-hidden">
        <div className="p-3 border-b border-slate-200 flex justify-between items-center">
          <h2 className="text-base font-bold text-[#2d3748] flex items-center gap-2">
            {title}
          </h2>
          <button onClick={handleClose} className="pr-2">
            <Close2 height={10} width={10} />
          </button>
        </div>

        <div className="p-3">
          {!items.length ? (
            <div className="text-center text-[#a0a0a0] py-4">
              <EmptyIcon height={30} width={30} color="#a0a0a0" />
              <h3 className="text-base md:text-lg">{emptyTitle}</h3>
              <p className="text-sm md:text-base">{emptyMessage}</p>
            </div>
          ) : (
            <div
              className={`hide-scrollbar border-b border-slate-200 pb-4 max-h-[300px] overflow-y-auto overflow-x-hidden -mx-4 pr-8 pl-4 ${
                items.length ? 'text-left' : 'text-center'
              }`}
            >
              {items.map((item, index) => (
                <div key={item.sku || item.id || index}>{renderItem(item)}</div>
              ))}
            </div>
          )}

          <div className="mt-3">
            {items.length ? (
              <Button
                color="orange"
                onClick={handleButtonClick}
                className="w-full text-sm font-bold h-10 flex items-center justify-center hover:shadow-lg hover:scale-[1.02] hover:brightness-110 transition-all duration-200 ease-in-out active:scale-95"
              >
                {buttonText}
              </Button>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  )
}

export default HeaderDropdown
